import mobx, { observable, action, toJS, computed } from 'mobx';
import _ from 'lodash';
import moment from 'moment';
import Cookies from 'js-cookie';

import api from '../../api';
import { dateTextFormat2 } from '../../common';
import dict from '../dictStore';

const TODAY_ID = 0;
const YESTERDAY_ID = 1;
const TWO_DAYS = 2;
const ANY_DATE = 3;
const SEC = 1000;
const MIN = 60 * SEC;
const HOUR = 60 * MIN;
const DAY = 24 * HOUR;

export default class Menu {

	@observable dict = {};
	@observable filter = null;
	@observable type = 0;
	@observable resultDate = 0;
	@observable mainScore = 0;
	@observable selectedSports = [];
	@observable selectedAll = false;
	@observable menu = null;
	@observable date_3 = null;
	date = null;
	@observable label = '';

	constructor(store, data) {
		this.store = store;
		this.dict = data.dict;
		this.menu = data.menu;
		if (this.store.mode == 'line') {
         this.filter = data.filter;
			this.getDate(this.resultDate);
			this.setLabel(this.filter.date[0]);
		}
	}

	@action setType(type) {
		if (this.type != type) {
			this.type = type;
			this.loadResult();
		}
	}

	@action setLabel(label) {
		this.label = label;
	}

	@action setDate(id, date) {
		if (this.resultDate != id || id == 3) {
			this.resultDate = id;
			this.getDate(id, date);
			this.loadResult();
		}
	}

	@action setMainScore() {
		this.mainScore = this.mainScore ? 0 : 1;
		this.loadResult();
	}

	@action getDisabled(id) {
		if (this.store.mode == 'live') {
			if (id !== 'other' && this.menu.current.indexOf(parseInt(id)) === -1) return true;
			if (id == 'other' && this.menu.other.length === 0 ) return true;
		}
		return false;
	}

	@action getDict(id) {
		if (id == 'other') {
			return dict.getLang('OTHER');
		}
		return this.dict.sport[id];
	}

	@action selectAll(){
		this.selectedAll = !this.selectedAll;
		this.selectedSports = [];
		this.loadResult();
	}

	@action selectSport(id) {
		this.selectedAll = false;
		const idx = this.selectedSports.indexOf(id);
		(idx === -1) ? this.selectedSports.push(id) : this.selectedSports.splice(idx, 1);
		this.loadResult();
	}

  getDate(date_id, date) {
   	let today = new Date(),
        date_from = '',
        date_to   = '';
    if (date_id === TODAY_ID) {
        date_from = today.getFullYear() + '-' + (today.getMonth() + 1).toString() + '-' + today.getDate();
        date_to   = date_from;
        this.setLabel(this.filter.date[date_id]);
    }
    else if (date_id === YESTERDAY_ID) {
        var yesterday = new Date(today.getTime()- DAY);
        date_from = yesterday.getFullYear() + '-' + (yesterday.getMonth() + 1).toString() + '-' + yesterday.getDate();
        date_to   = date_from;
        this.setLabel(this.filter.date[date_id]);
    }
    else if (date_id === TWO_DAYS) {
        const yesterday2 = new Date(today.getTime()- DAY);
        date_from = yesterday2.getFullYear() + '-' + (yesterday2.getMonth() + 1).toString() + '-' + yesterday2.getDate();
        date_to   = today.getFullYear() + '-' + (today.getMonth() + 1).toString() + '-' + today.getDate();
        this.setLabel(this.filter.date[date_id]);
    }
    else if (date_id === ANY_DATE) {
        date_from = moment(date).format('YYYY-MM-DD');
        date_to   = date_from;
        this.setLabel(dateTextFormat2(date));
    }

    this.date =  {
        from : date_from,
        to   : date_to
    };


  }

   @action clear() {
      this.selectedSports = [];
      this.selectedAll = 0;
   }

  @action loadResult() {
  	if (this.selectedSports.length === 0 && !this.selectedAll) {
  		this.store.setError('SELECT_SPORT');
  		this.store.results.clear();
  		return false;
  	}

  	let data = {};
  	let sport = [];

  	if (this.store.mode == 'live') {
  		this.selectedSports.forEach(item => {
  			if (!this.getDisabled(item)) {
	  			if (item == 'other') {
	  				sport = sport.concat(this.menu.other.peek());
	  			} else {
	  				sport.push(item);
	  			}
	  		}
  		})
  		if (sport.length === 0) {
	  		this.store.setError('SELECT_SPORT');
	  		this.store.results.clear();
	  		return false;
	  	}
  	}

  	if (this.store.mode == 'line') {
  		data.timezone_id = +Cookies.get('timezone') || 3;
  		data.is_live = this.type;
  		data.main_score = this.mainScore;
  		data.date_from = toJS(this.date.from);
  		data.date_to = toJS(this.date.to);
  		data.site_type = this.store.cashboxId == 2 ? 1 :0;
			data.language_id = 1049;

  		if (this.type === 1) {
				if (this.selectedAll) {
					data.sports = Object.keys(this.menu.comparison);
				} else {
					data.sports = toJS(this.selectedSports);
				}
  		} else if (this.selectedAll) {
				data.sports = toJS(this.menu.order);
			} else {
				data.sports = this.selectedSports.peek();
  		}
  	} else if (this.store.mode == 'live') {
			data.sports = sport;
  	}

		if (toJS(this.selectedSports).includes('other')) {
			data.include_other = 1;
		} else data.include_other = 0;

		data.sports = data.sports.filter(item => item !== 'other');


		this.store.results.loadResult(data);
	}
}


// WEBPACK FOOTER //
// ./src/stores/resultStore/menu.js